import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import LoaderGif from '../../../icons/LoaderGif.gif';
import { Modal } from 'react-bootstrap';
import CheckBox from '../../CheckBox';
import { usersAdding, usersAddError } from '../../../screens/Admin/selectors';
import { addUserRequested } from '../../../screens/Admin/actions';

function ChangeRole({
    open,
    user,
    onCancel,
    totalAdminsCount,
    currentAdminsCount,
    totalCitizenScientistCount,
    currentCitizenScientistCount,
}) {
    const dispatch = useDispatch();
    const [owner, setOwner] = useState(false);
    const [admin, setAdmin] = useState(false);
    const [researcher, setResearcher] = useState(false);
    const { roleIds, isCreator } = user;
    const hasAdminRole =
        (roleIds && roleIds.filter((item) => item >= 300).length > 0) || false;
    const hasResearcherRole =
        (roleIds &&
            roleIds.filter((item) => item >= 200 && item < 300).length > 0) ||
        false;
    const loading = useSelector((state) => usersAdding(state));
    const error = useSelector((state) => usersAddError(state));

    const [showError, setShowError] = useState(false);

    useEffect(() => {
        setOwner(isCreator || false);
        setAdmin(hasAdminRole);
        setResearcher(hasResearcherRole);
    }, [roleIds]);

    useEffect(() => {
        setShowError(false);
    }, [open]);

    const onSave = () => {
        setShowError(true);
        const roles = [];
        owner && roles.push('OWNER');
        admin && roles.push('PARTNER');
        researcher && roles.push('EXPERT_INDIVIDUAL');
        dispatch(addUserRequested(user.email, roles));
    };

    useEffect(() => {
        !loading && !error && onCancel();
    }, [loading]);

    return (
        <div className="admin-delete-modal">
            <Modal
                show={open}
                onHide={onCancel}
                dialogClassName={'admin-delete-modal'}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                centered={true}
                animation={true}
            >
                <div className="row">
                    <div className="col-12">
                        <div className="row title">
                            Change/Remove User Role(s)
                        </div>
                        <div className="row">Please select the role(s)</div>
                        <>
                            <div
                                className="row justify-content-around"
                                style={{ padding: '15px 0px' }}
                            >
                                <CheckBox
                                    label={'Owner'}
                                    id={`user-checkbox-owner`}
                                    onClick={(e) => setOwner(e.target.checked)}
                                    isBold={true}
                                    selected={owner}
                                />
                                <CheckBox
                                    label={'Admin'}
                                    id={`user-checkbox-admin`}
                                    onClick={(e) => setAdmin(e.target.checked)}
                                    isBold={true}
                                    selected={admin}
                                    disabled={
                                        totalAdminsCount === currentAdminsCount
                                    }
                                />
                                <CheckBox
                                    label={'Researcher'}
                                    id={`user-checkbox-researcher`}
                                    onClick={(e) =>
                                        setResearcher(e.target.checked)
                                    }
                                    isBold={true}
                                    selected={researcher}
                                    disabled={
                                        totalCitizenScientistCount ===
                                        currentCitizenScientistCount
                                    }
                                />
                            </div>
                        </>
                        <div className="row">{showError ? error : ''}</div>
                        <div className="row">
                            <button
                                className={'btn btn-block delete-admin-button'}
                                type={'button'}
                                disabled={!(owner || admin || researcher)}
                                onClick={() => onSave()}
                            >
                                {loading ? (
                                    <img
                                        src={LoaderGif}
                                        width={'25px'}
                                        height={'25px'}
                                    />
                                ) : (
                                    'Save'
                                )}
                            </button>
                        </div>

                        <div className="row mt-1">
                            <button
                                className={'btn btn-block delete-button-cancel'}
                                type={'button'}
                                onClick={onCancel}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

ChangeRole.propTypes = {
    open: PropTypes.bool,
    user: PropTypes.object,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    canRemoveOwner: PropTypes.bool,
    totalAdminsCount: PropTypes.number,
    currentAdminsCount: PropTypes.number,
    totalCitizenScientistCount: PropTypes.number,
    currentCitizenScientistCount: PropTypes.number,
};

ChangeRole.defaultProps = {
    open: false,
    canRemoveOwner: false,
    user: {},
    onCancel: () => {},
    onConfirm: () => {},
    totalAdminsCount: 0,
    currentAdminsCount: 0,
    totalCitizenScientistCount: 0,
    currentCitizenScientistCount: 0,
};

export default ChangeRole;
